import { IGenericComponentInModalProps } from '@app/components/modal/IGenericComponentInModalProps'
import { useAxios } from '@app/utils/useAxios'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { BackofficeAPIConfig } from '@lib/Core/API/BackofficeAPIConfig'
import { BackofficeApiActions } from '@lib/Core/API/BackofficeApiActions'
import { getErrorMessage } from '@lib/Error/getErrorMessage'
import { Grid, GridItem, Spinner } from '@patternfly/react-core'
import { IEvaluation } from '../IData'

const componentReadEvaluation: React.FunctionComponent<IGenericComponentInModalProps> = (props: IGenericComponentInModalProps) => {
  // Fixed
  const api = useAxios()
  const history = useHistory()
  const modalTitles = {
    read: 'Viewing evaluation',
  }

  // Reactive
  const [action, setAction] = React.useState<string>(props.data.action)
  const [id, setId] = React.useState<number | undefined>(props.data.id)
  const [loading, setLoading] = React.useState<boolean>(true)

  const [evaluation, setEvaluation] = React.useState<IEvaluation | undefined>(undefined)

  React.useEffect(() => {
    setLoading(true)
    props.setTitle(modalTitles[action])

    const abortController = new AbortController()

    const fetchEvaluation = async (id: number) => {
      try {
        const response = await api.current?.post(BackofficeAPIConfig.Domains.Data, {
          action: BackofficeApiActions.ReadEvaluation,
          data: {
            id,
          },
        })
        if (response?.data.result) {
          return response?.data.result as IEvaluation
        } else {
          throw new Error('No data set received.')
        }
      } catch (error) {
        throw error
      }
    }

    const fetchAll = async (id: number) => {
      const ev = await fetchEvaluation(id)
      setEvaluation(ev)
    }

    if (id) {
      fetchAll(id)
        .catch((error) => {
          alert(getErrorMessage(error))
        })
        .finally(() => {
          setLoading(false)
        })
    }

    return () => {
      abortController.abort()
    }
  }, [action])

  React.useEffect(() => {
    props.onBeforeCloseModal.once((_props) => {
      history.push(`/data/main`)
    })
  })

  return (
    <React.Fragment>
      {loading && <Spinner></Spinner>}
      {!loading && (
        <Grid hasGutter>
          <GridItem span={4}>
            <strong>ID:</strong> {evaluation?.id}
          </GridItem>
          <GridItem span={4}>
            <strong>Customer ID:</strong> {evaluation?.customerId}
          </GridItem>
          <GridItem span={4}>
            <strong>Source:</strong> {evaluation?.source}
          </GridItem>
          <GridItem span={4}>
            <strong>Line Item ID:</strong> {evaluation?.lineItemId}
          </GridItem>
          <GridItem span={4}>
            <strong>SKU:</strong> {evaluation?.sku}
          </GridItem>
          <GridItem span={4}>
            <strong>Is Successful:</strong> {evaluation?.isSuccessful ? 'Yes' : 'No'}
          </GridItem>
          <GridItem span={12}>
            <strong>Created At:</strong> {evaluation?.createdAt}
          </GridItem>
          <GridItem span={12}>
            <strong>User Message:</strong> {evaluation?.user_message}
          </GridItem>
        </Grid>
      )}
    </React.Fragment>
  )
}

const ReadEvaluation = React.memo(componentReadEvaluation)

export { ReadEvaluation }
